import Close16 from '@carbon/icons-react/es/close/16';
import { Skeleton } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { OzoneDrawer } from 'components/atoms/drawer';
import { EmptyState as BaseEmptyState } from 'components/atoms/empty-state';
import { Caption01 } from 'components/styles';

const Caption = styled.p`
  ${Caption01};
  margin: 0;
`;

export const DullCaption = styled(Caption)`
  color: var(--gray-50);
`;

export const Drawer = styled(OzoneDrawer).attrs(({ showTaskColumn }) => ({
  width: showTaskColumn ? 968 : 816,
  placement: 'right',
  closeIcon: <Close16 />,
}))`
  .drawer__body {
    padding: 0;
  }
`;

export const DrawerBody = styled.div`
  height: calc(100vh - 172px);
  overflow: scroll;
  padding: var(--spacing-06);
`;
export const EmptyState = styled(BaseEmptyState)`
  height: 80%;
  justify-content: center;
  padding-left: var(--spacing-11);
`;

export const Loading = ({ onClose, visible }) => {
  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      destroyOnClose
      title={<FormattedMessage id="timesheets.integration.drawer.title" />}
    >
      <DrawerBody>
        <Skeleton paragraph={{ rows: 2, width: '100%' }} />
      </DrawerBody>
    </Drawer>
  );
};

export const Footer = styled.div`
  padding: var(--spacing-06) var(--spacing-07);
  border-top: 1px solid var(--gray-20);
`;

export const TopSelection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: var(--spacing-05);
`;

export const SelectCalenderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  > div {
    width: 50%;
  }
`;
